import React from 'react'
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom'

if (typeof window !== 'undefined') {
  const origError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (message && typeof message === 'string' && message.includes('ResizeObserver')) {
      return true;
    }
    if (origError) {
      return origError(message, source, lineno, colno, error);
    }
    return false;
  };
  
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  const OrigResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OrigResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {}
        });
      });
    }
  };
}
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UserProvider } from './context/UserContext';
import { SettingsProvider } from './context/SettingsContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { MemberAuthProvider } from './context/MemberAuthContext';
import theme from './theme';

import './style.css'
import Home from './views/home'
import Register from './views/registration'
import Donation from './views/donation'
import Admin from './views/admin'
import NotFound from './views/not-found'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import RulesBook from './components/RulesBook';
import { Success, Failure } from './components/PaymentConfirmation';
import MemberRota from './components/MemberRota';
import Members from './views/members';
import ScrollToTop from './components/ScrollToTop';
import { ChatBotProvider } from './context/ChatBotContext';
import ChatBot from './components/ChatBot';

const App = () => {
  return (  
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SettingsProvider>
          <AdminAuthProvider>
          <MemberAuthProvider>
            <UserProvider>
              <Router>
              <ChatBotProvider>
              <ScrollToTop />
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<Register />} />
              <Route path="/donation" element={<Donation />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/rules" element={<RulesBook />} /> 
              <Route path="/payment/success" element={<Success />} />
              <Route path="/payment/failure" element={<Failure />} />
              <Route path="/duty-manager" element={<MemberRota />} />
              <Route path="/members" element={<Members />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
              <ChatBot />
              <Box
                component="footer"
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  py: 1.5,
                  mt: 'auto',
                  borderTop: '1px solid #e0e0e0',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem' }}>
                  Created by <a href="https://www.akendi.com/uk" target="_blank" rel="noopener noreferrer" style={{ color: '#999', textDecoration: 'underline' }}>Akendi</a>, giving back to the community
                </Typography>
              </Box>
              </ChatBotProvider>
              </Router>
            </UserProvider>
          </MemberAuthProvider>
          </AdminAuthProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </ThemeProvider>
  )
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);